export { ProductReference } from './product-reference.component';
